/* 地址选项dialog */

<template>
  <div>
    <z-dialog :title="title" v-model="display" @close="closeDialog" @submit="submit">
      <div :class="preflxCls">
        <div class="zAddresslog-com">
          <div v-if="lists.length > 0">
            <Row
              :gutter="20"
              v-for="(item, index) in lists"
              :key="index"
              type="flex"
              justify="center"
              align="middle"
              class="address-item"
            >
              <Col span="2" class="icon">
                <i class="iconfont icon-coordinate"></i>
              </Col>
              <Col span="20" class="detail">
                <div class="name">
                  收货人：{{item.userName}}
                  <Tag
                    color="primary"
                    class="defaultBtn"
                    v-if="item.isDefault === 1"
                  >默认地址</Tag>
                </div>
                <div class="phone">联系方式：{{item.userMobile}}</div>
                <div class="detailAds">详细地址：{{addressFilter(item.detailAddress, 'all')}}</div>
              </Col>
              <Col span="2">
                <Radio size="large" @on-change="choiceAds(item, index)" v-model="item.choiced"></Radio>
              </Col>
            </Row>
          </div>
          <z-empty v-else txt="暂时还没有创建地址哦！"></z-empty>
        </div>
        <z-page
          :total="total"
          :pageSize="filter.pageSize"
          v-model="filter.pageNum"
          @changePageNum="changePageHandel"
        ></z-page>
      </div>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "zAddresslog";
import { findComponentDownward } from "../../utils/assist.js";
import ZPage from "../page/page";
import Zempty from "../empty/empty";
import Emitter from "../../mixins/emitter.js";
import _ from "lodash";
export default {
  name: "ZAddresslog",
  provide() {
    return {
      app: this
    };
  },
  mixins: [Emitter],
  data() {
    return {
      preflxCls: preflxCls,
      diaologDom: null,
      filter: {
        pageNum: 1,
        pageSize: 5
      }
    };
  },
  components: { ZPage, Zempty },
  props: {
    lists: {
      type: Array,
      default: function() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "暂无标题"
    },
    width: {
      type: [Number, String],
      default: 360
    },
    // button text
    btnTxt: {
      type: [Number, String],
      default: "确定"
    },
    // 是否是长按钮
    long: {
      type: Boolean,
      default: false
    },
    // 是否需要取消
    cel: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: "zhulogicModule"
    }
  },
  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    // 选择
    choiceAds(item, index) {
      _.forEach(this.lists, element => {
        element.choiced = false;
      });
      item.choiced = !item.choiced;
    },
    // 改变页面页码
    changePageHandel(page) {
      this.filter.pageNum = page;
      this.$emit('changePage',this.filter)
    },
    // 确定提交
    submit() {
      let newAddress = _.find(this.lists, { choiced: true });
      if (!newAddress) {
        this.$Message.error("请选择地址！");
        return false;
      }
      this.$emit("submitAddress", newAddress);
    }
  }
};
</script>

